const firebaseConfig = {
    apiKey: "AIzaSyCAIUt6G0Y8kTEl0XuicIMW3tI7X7__lxY",
    authDomain: "urban-riders-c24c7.firebaseapp.com",
    projectId: "urban-riders-c24c7",
    storageBucket: "urban-riders-c24c7.appspot.com",
    messagingSenderId: "835818869315",
    appId: "1:835818869315:web:718b87c3cf6f3beaec3af6"
  };

  export default firebaseConfig;